import { Check, ArrowRight } from "lucide-react";
import { Container, Eyebrow, Section, Reveal } from "./common";
import { SERVICIOS, PILARES } from "../data/content";

export const Servicios = () => {
  return (
    <Section id="servicios">
      <Container>
        <Reveal>
          <Eyebrow>Raíz Commerce · El articulador</Eyebrow>
          <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
            Cómo lo <span className="text-rc-sage italic">construimos</span> en la práctica
          </h2>
          <p className="mt-6 max-w-2xl text-stone-400 font-light leading-relaxed">
            Cada servicio opera por sí solo y suma al conjunto. El punto de entrada siempre es un
            diagnóstico gratuito — porque cada municipio, institución y negocio parte de un lugar distinto.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
          {SERVICIOS.map((s, i) => (
            <Reveal key={s.n} delay={(i % 2) * 0.1}>
              <div className="h-full p-8 md:p-10 rounded-2xl bg-rc-card border border-rc-border hover:border-rc-sage/40 transition-all duration-300">
                <div className="font-mono text-sm text-rc-terra tracking-widest">SERVICIO {s.n}</div>
                <h3 className="mt-5 font-serif text-2xl text-stone-100">{s.title}</h3>
                <p className="mt-3 text-stone-400 font-light leading-relaxed">{s.text}</p>
                <ul className="mt-6 space-y-2.5">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-sm text-stone-300">
                      <Check className="w-4 h-4 text-rc-sage mt-0.5 shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-24">
          <Reveal>
            <Eyebrow>Vertiente municipal</Eyebrow>
            <h2 className="mt-5 font-serif font-light text-2xl sm:text-3xl lg:text-4xl tracking-tight text-stone-100">
              Tres pilares que se despliegan <span className="text-rc-sage italic">en cascada</span>
            </h2>
          </Reveal>

          <div className="mt-12 grid md:grid-cols-3 gap-6 lg:gap-8">
            {PILARES.map((p, i) => (
              <Reveal key={p.n} delay={i * 0.1}>
                <div className="relative h-full p-8 rounded-2xl bg-rc-bg2 border border-rc-border">
                  <div className="w-10 h-10 rounded-full bg-rc-forest flex items-center justify-center font-serif text-lg text-stone-100">
                    {p.n}
                  </div>
                  <h3 className="mt-5 font-serif text-xl text-stone-100">{p.title}</h3>
                  <div className="mt-1 text-xs font-mono text-stone-500 uppercase tracking-wider">{p.sub}</div>
                  <ul className="mt-5 space-y-2">
                    {p.bullets.map((b) => (
                      <li key={b} className="flex items-start gap-2.5 text-sm text-stone-400">
                        <span className="w-1 h-1 rounded-full bg-rc-sage mt-2 shrink-0" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 p-8 rounded-2xl bg-gradient-to-r from-rc-forest/20 to-rc-card border border-rc-border">
              <p className="font-serif text-lg text-stone-200 max-w-xl">
                El primer paso es un <span className="text-rc-sage italic">diagnóstico gratuito de 72 horas.</span>{" "}
                Sin compromiso, con un entregable concreto.
              </p>
              <a
                href="/#contacto"
                data-testid="servicios-diagnostico-btn"
                className="group inline-flex items-center gap-2 px-6 py-3 rounded-full bg-rc-forest hover:bg-rc-forestlight text-stone-100 transition-colors whitespace-nowrap"
              >
                Solicitar diagnóstico
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </Reveal>
        </div>
      </Container>
    </Section>
  );
};
